import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=706dc5f9"
import script from "./FormGenerator.vue?vue&type=script&lang=js"
export * from "./FormGenerator.vue?vue&type=script&lang=js"
import style0 from "./FormGenerator.vue?vue&type=style&index=0&id=706dc5f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports